// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1Mk_U","select":"Header_select__1fI6-","clinic":"Header_clinic__3D8Ka"};